/* Import hugerte */
import 'hugerte'

/* Required imports */
import 'hugerte/icons/default'
import 'hugerte/models/dom'
import 'hugerte/themes/silver'

/* Skin */
import 'hugerte/skins/ui/oxide/skin.css'

/* Plugins */
import 'hugerte/plugins/autolink'
import 'hugerte/plugins/emoticons'
import 'hugerte/plugins/emoticons/js/emojis'
import 'hugerte/plugins/help'
import 'hugerte/plugins/link'
import 'hugerte/plugins/lists'
import 'hugerte/plugins/media'
import 'hugerte/plugins/wordcount'

const defaultElements = [
  `a[href|target]`,
  'strong',
  'em',
  'p',
  'span',
  'ul',
  'ol',
  'li',
  'b',
  'i',
  's',
  'br',
]

// The elements and attributes we support, when inserting media is allowed
const mediaElements = [
  `iframe[src|width|height|allowfullscreen|frameborder|allow]`,
  `video[src|width|height|controls|poster|type]`,
  `source[src|width|height|allowfullscreen|frameborder|allow]`,
]

const hugerteConfigBase = {
  branding: false,
  elementpath: false,
  height: 200,
  max_height: 700,
  menubar: false,
  min_height: 250,
  paste_as_text: false,
  valid_elements: defaultElements.join(','),
  content_style:
    "@import url('https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i'); body { font-family: 'Lato', sans-serif; padding: 8px;} p { line-height: 1.5; margin: 0 0 12px 0; hyphens: auto;}",
  font_formats: 'Lato=lato;',
  link_title: false,
  relative_urls: false,
  remove_script_host: false,
}

const hugerteConfigDefault = {
  ...hugerteConfigBase,
  contextmenu: 'cut copy | removeformat | link',
  plugins: 'emoticons link lists media paste',
  toolbar:
    'undo redo | cut copy | bold italic strikethrough | selectall removeformat | numlist bullist | emoticons | link',
  media_live_embeds: true,
}

const hugerteConfigProductDescription = {
  ...hugerteConfigBase,
  contextmenu: 'cut copy | removeformat | link',
  plugins: 'emoticons link',
  toolbar:
    'undo redo | paste cut copy | bold italic strikethrough | selectall removeformat | emoticons | link | aiButton',
}

const hugerteConfigNews = {
  ...hugerteConfigBase,
  valid_elements: [...defaultElements, ...mediaElements].join(','),
  contextmenu: 'cut copy | removeformat | link',
  plugins: 'emoticons link lists media paste',
  toolbar:
    'undo redo | cut copy | bold italic strikethrough | selectall removeformat | numlist bullist | emoticons | link media',
  media_live_embeds: true,
  height: '100%',
  resize: false,
  statusbar: false,
}

// Preset system for easy configuration selection
export const HUGERTE_PRESETS = {
  default: hugerteConfigDefault,
  product: hugerteConfigProductDescription,
  news: hugerteConfigNews,
}
